import React from 'react'
import PropTypes from 'prop-types'
import { string, compose } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import Message from 'components/text/Message/Message'
import Link from 'components/ui/Link/Link'

import messages from './messages.js'
import s from './PageResult.scss'


const PageResult = ({ index, page: { name, url }, page, onClick, intl }) => {
  const safeName = string.trimHtml(name)

  return (
    <Link
      className={s.link}
      to={url}
      onClick={() => onClick({ page: { ...page, name: safeName }, position: index + 1 })}
      blackToBrandColor
      aria-label={intl.formatMessage(messages.goTo, { pageName: `${safeName}` })}
    >
      <Message tag="div" className={s.name} text={name} html />
    </Link>
  )
}

PageResult.propTypes = {
  index: PropTypes.number,
  page: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,

  intl: PropTypes.object, // @injectIntl
}


export default compose(
  injectIntl,
)(PageResult)
